<template>
  <div class="text-shadow">
    <el-tooltip effect="dark" content="例: rgba(255, 255, 255, 0.6)" placement="top">
      <el-input class="color-input" placeholder="rgba值"
                @click.native="openColorPicker"
                @change="onTextShadowColorChange"
                v-model="textShadowColor">
                  <span slot="suffix">
                       <i class="myico-colors" style="color: #000000"></i>
                       <el-color-picker ref="colorRef" @click.native="openColorPicker"
                                        show-alpha
                                        popper-class="picker-no-button"
                                        class="input-color-picker"
                                        @active-change="onTextShadowColorChange"
                                        v-model="textShadowColor"></el-color-picker>
                  </span>
      </el-input>
    </el-tooltip>
    <el-tooltip effect="dark" content="扩展度" placement="top">
      <el-input type="text" class="ts-px" v-model="textShadowPx"
                @change="onTextShadowPxChange"><span class="c-ipt-suffix" slot="suffix">px</span></el-input>
    </el-tooltip>
  </div>
</template>
<script>
  export default {
    props: {
      value: String
    },
    data () {
      return {
        textShadowPx: null,
        textShadowColor: null,
        textShadow: ['', ''],
      };
    },
    watch: {
      value: {
        handler () {
          this.init();
        },
        immediate: true
      }
    },
    methods: {
      init () {
        this.initTextShadow();
      },
      initTextShadow () {
        if (!this.value) {
          this.clearData();
          return;
        }
        let str = this.value;
        let px = str.substring(str.indexOf(')') + 1).trim(); // 5px 5px;;
        this.textShadowPx = px.split(' ')[0].replace('px', '');
        this.textShadowColor = str.substring(0, str.indexOf(')') + 1);
      },
      clearData () {
        this.textShadowPx = null;
        this.textShadowColor = null;
        this.textShadow = ['', ''];
      },
      openColorPicker () {
        this.$refs.colorRef.$el.querySelector('.el-color-picker__icon').click();
      },
      onTextShadowColorChange (color) {
        this.textShadowColor = color;
        this.textShadow[0] = color;
        this.setTextShadow();
      },
      onTextShadowPxChange (pxValue) {
        this.textShadow[1] = pxValue ? `${pxValue}px ${pxValue}px` : '';
        this.setTextShadow();
      },
      setTextShadow () {
        let val = '';
        let colorVal = this.textShadow[0].trim();
        let pxVal = this.textShadow[1].trim();
        if(colorVal && pxVal){
          val = this.textShadow.join(' ');
          this.$emit('onChangeBefore', val);
          this.$emit('input', val);
          this.$emit('change', val);
        }else if(colorVal === '' && pxVal === ''){
          this.$emit('onChangeBefore', val);
          this.$emit('input',val);
          this.$emit('change', val);
        }
      },
    }
  }
</script>
<style lang="scss">
  @import "./index";
</style>